<template>
  <el-card class="worktime-preview box-card">
    <div slot="header" class="clearfix">
      <span>{{title}}</span>
    </div>
    <div class="calendar" ref="calendarContainer"></div>
  </el-card>
</template>
<script>
export default {
  name: "preview",
  props:['formData', 'isNew'],
  watch:{
    formData:{
      handler:function(val,oldval) {  
        if (oldval !== undefined) {
          this.removeCaledarEvents();
          if (val.id || this.isNew) {
            this.initCalendar();
          }
        }
      },  
      immediate:true,
      deep:true
    },
  },
  data() {
    return {
      title: "工作时间与休假时间设置",
      calendar: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initCalendar();
    });
  },
  methods: {
    initWorkdayEvent(startDate, endDate) {
      let me = this;
      const workdaysList = me.formData.workdaysList;
      const holidays = me.formData.holidays;  // 节假日
      const restdays = me.formData.restdays;  // 休息日上班
      Date.prototype.formatCurDate = function() {
        var s = '';
        var mouth = (this.getMonth() + 1)>=10?(this.getMonth() + 1):('0'+(this.getMonth() + 1));
        var day = this.getDate()>=10?this.getDate():('0'+this.getDate());
        s += this.getFullYear() + '-'; // 获取年份。
        s += mouth + "-"; // 获取月份。
        s += day; // 获取日。
        return (s); // 返回日期。
      };
  
      function getAll(begin, end) {
        let arr = [];
        var ab = begin.split("-");
        var ae = end.split("-");
        var db = new Date();
        db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
        var de = new Date();
        de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
        var unixDb = db.getTime();
        var unixDe = de.getTime();
        for (var k = unixDb; k <= unixDe;) {
            // 判断是否工作日
            let d = new Date(parseInt(k));
            let dd = d.getDay();
            let dmd = d.formatCurDate().substr(5, 5);
            if (($.inArray(dd.toString(), workdaysList) !== -1 && holidays.indexOf(dmd) < 0) || ($.inArray(dd.toString(), workdaysList) == -1 && restdays.indexOf(dmd) !== -1)) {
              // 1. 在工作日内 且不在节假日内 才加入工作时间 2.不在工作日内 但在休息日上班时间内, 加入工作时间
              arr.push({
                start: d.formatCurDate(),
                title: '班',
                className: 'a-worktime',
              });
            }
            k = k + 24 * 60 * 60 * 1000;
        }
        return arr;
      }
      return getAll(startDate, endDate);
    },
    initCalendar() {
      let cssList = ['/assets/css/fullcalendar/fullcalendar.min.css'];
      let jsList = ['/assets/js/fullcalendar/fullcalendar.min.js','/assets/js/fullcalendar/zh-cn.js'];
      PF.loadCss(cssList);
      PF.requireJs(jsList, (res)=>{
        let me = this;
        this.calendar = $(me.$refs.calendarContainer).fullCalendar({
          defaultView: "month",
          selectable: true,
          aspectRatio: 2.5,
          firstDay: 0,
          header: {
            left: 'title',
            center: '',
            right: 'prev,today,next'
          },
          views: {
            month: {
              titleFormat: "YYYY-MM"
            }
          },
          dayClick: (date, allDay, jsEvent, view) => {
            me.setSpecialDay(date.format('YYYY-MM-DD'));
          },
          eventClick: (event, jsEvent, view) => {
            me.setSpecialDay(event.start.format('YYYY-MM-DD'));
          },
        });
        this.calendar.fullCalendar('addEventSource', (start,end,timezone,callback) => {
          let events = [];
          this.removeCaledarEvents();
          events = this.initWorkdayEvent(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
          callback(events);
        })
      });
    },
    setSpecialDay(date) {
      this.$emit('setSpecialDay', date);
    },
    refetchCaledar(){
      if (this.calendar) this.calendar.fullCalendar('refetchEvents');
    },
    removeCaledarEvents() {
      if (this.calendar) this.calendar.fullCalendar('removeEvents');
    },
    setIsNew(){
      this.$emit('setIsNew');
    },
    updateWorkDayState(date, type){
      if (type == 'remove') {
        this.calendar.fullCalendar('removeEvents', (event) => {
          return event.start && event.start.format("YYYY-MM-DD") == date;
        });
      } else if (type == 'add') {
        this.calendar.fullCalendar('addEventSource', (start,end,timezone,callback) => {
          let event = [{
            start: date,
            title: '班',
            className: 'a-worktime',
          }];
          callback(event);
        });
      }
    }
  }
};
</script>
<style>
.worktime-preview .setting-btn {
  float: right; padding: 4px 6px; margin-left: 8px;
}
.worktime-preview .setting-btn.selected {
  background-color: #dddddd;
}
.worktime-preview .a-worktime {
  height: 16px !important;
  width: 16px !important;
  border-radius: 50% !important;
  color: #3a87ad !important;
  background-color: white !important;
  border: solid 1px #3a87ad !important;
  padding: 8px 8px !important;
  margin: -8px auto 0 auto !important;
}
.worktime-preview .a-worktime .fc-content,
.worktime-preview .a-worktime .fc-content .fc-title  {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/worktimePreview.vue